export default __webpack_public_path__ + "static/media/page_not_found.813042fe.gif";